import { render } from "./Logo.vue?vue&type=template&id=5e892bbf&scoped=true"
const script = {}

import "./Logo.vue?vue&type=style&index=0&id=5e892bbf&lang=scss&scoped=true"

import exportComponent from "/Users/apple/Documents/yang/wms-image/wms-image-pc/Commodity_Wms_Pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e892bbf"]])

export default __exports__